import { h } from '@atomify/jsx';

import createImageUrl from './utilities/create-image-url';
import { ImageMode, ImageSetting, ImageSettings } from './utilities/image';

export interface ImageInterface {
    image: string;
    alt: string;

    settings?: ImageSettings;
    preload?: ImageSetting;
    mode?: ImageMode;

    classes?: string;
    caption?: string;

    hidden?: boolean;
    objectFit?: boolean | 'contain';
    disableCrossFade?: boolean;
}

export const Image = (data: ImageInterface) => {
    const preload = data.preload
        ? createImageUrl({
              image: data.image,
              setting: data.preload,
              mode: data.mode,
          })
        : false;

    return (
        <bpd-image class={`c-image ${data.classes ? data.classes : ''}`} mode={data.mode}>
            <figure {...{ 'js-hook-objectfit-container': data.objectFit }}>
                <img
                    class={data.disableCrossFade ? '' : 'image__default'}
                    data-image={data.image}
                    alt={data.alt}
                    {...{
                        src: preload ? preload : false,
                        'data-settings': JSON.stringify(data.settings),
                        'js-hook-objectfit-img': data.objectFit,
                        hidden: data.hidden,
                    }}
                />
            </figure>

            {data.caption && <figcaption class="c-image__caption">{data.caption}</figcaption>}
        </bpd-image>
    );
};
